import * as React from 'react';
import styles from './index.less';

interface IntroductionCardProps {
  text: string;

  onClick?(): void;
}

function IntroductionCard({ text, onClick }: IntroductionCardProps) {

  if (text !== '') {
    return (<div className={styles.IntroductionCard_hasDate} onClick={onClick}>
      {text}
    </div>);
  }

  return (<div className={styles.IntroductionCard} onClick={onClick}>
    <span>添加简介</span>
  </div>);
}

export default IntroductionCard;
